import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

const REFRESH_INTERVAL_MS = 60_000;

function toggleFullscreenElement(target) {
  if (!target) return;
  if (document.fullscreenElement) {
    if (document.exitFullscreen) {
      document.exitFullscreen().catch(() => {});
    }
    return;
  }
  const el = target;
  const request = el.requestFullscreen
    || el.webkitRequestFullscreen
    || el.msRequestFullscreen;
  if (request) {
    request.call(el).catch(() => {});
  }
}

export default function useTvKiosk() {
  const location = useLocation();
  const isTvMode = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('tv') === '1';
  }, [location.search]);

  const [refreshToken, setRefreshToken] = useState(0);

  useEffect(() => {
    if (!isTvMode) return undefined;
    const id = setInterval(() => {
      setRefreshToken(prev => prev + 1);
    }, REFRESH_INTERVAL_MS);
    return () => clearInterval(id);
  }, [isTvMode]);

  useEffect(() => {
    if (!isTvMode) return undefined;
    document.body.classList.add('shipments-tv-dark');
    return () => {
      document.body.classList.remove('shipments-tv-dark');
    };
  }, [isTvMode]);

  const toggleFullscreen = useCallback(() => {
    toggleFullscreenElement(document.documentElement);
  }, []);

  return {
    isTvMode,
    hideChrome: isTvMode,
    refreshToken,
    toggleFullscreen
  };
}
